<cx-cart-totals></cx-cart-totals>
<cx-cart-proceed-to-checkout></cx-cart-proceed-to-checkout>
<!-- TODO: estilos, layout -->
